import angular from 'angular';

import { ContainerQuickActionsAngular } from './container-quick-actions';

export const componentsModule = angular
  .module('shbdeployer.docker.components', [])
  .component('containerQuickActions', ContainerQuickActionsAngular).name;
